module.exports = __webpack_public_path__ + "img/sjk1.010e796a.png";